









































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import {
  Dictionary,
  EUserStatus,
  IBatch,
  IFacility,
  IFacilityAdvancedSettings,
  IFacilityCollectionSettings,
  isObj,
  isString,
  IUser,
  UserAssignment,
  UserBatchesReassignmentData,
  UserReassignment
} from '@zunta/configurations'
import Select from '@/components/Select.vue'
import ScrollView from '@/components/ScrollView.vue'
import { UserModule } from '@/store/modules/user.module'
import { getModule } from 'vuex-module-decorators'
import { FacilityModule } from '@/store/modules/facility.module'
import ErrorMessages from '@/components/ErrorMessages.vue'
import { BatchModule } from '@/store/modules/batch.module'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import Icon from '@/components/Icon.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import Card from '@/components/Card.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import ProgressCheckbox from '@/views/app/management/settings/components/ProgressCheckbox.vue'

@Component({
  components: { ProgressCheckbox, Checkbox, LoaderWrapper, Card, InputValidator, Icon, ModalV2, SelectV2, ErrorMessages, ScrollView, Select, Modal },
  props: {
    userToDelete: {
      type: Number,
      required: true
    },
    revokeUserAccess: {
      type: Boolean,
      default: false
    }
  }
})
export default class DisableUserModal extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  batchModuleInstance: BatchModule = getModule(BatchModule, this.$store)
  userAssignments: UserAssignment[] = []
  userReassignmentsByFacility: Dictionary<UserReassignment> = {}
  isLoading: boolean = false
  errors: string[] = []
  openedSections: number[] = []
  showAutofillAll: boolean = false
  showAutofillMap: Record<number, boolean> = {} // facilityId - T/F
  autofillAllUser: number | null = null
  autofillUserMap: Record<number, number> = {} // facilityId - userId

  get userAssignmentsStore () {
    return this.$store.state.user.userAssignments
  }

  get paymentSettingFields () {
    return (facility: any) => Object.keys(facility).filter((key: string) => ['paymentsReviewManager', 'syncPaymentUser'].includes(key))
  }

  get advancedSettingsFields () {
    return (facility: any) => {
      const fields: string[] = []
      facility.advancedSettings.forEach((setting: Partial<IFacilityAdvancedSettings>[]) => {
        fields.push(...Object.keys(setting).filter((key: string) => key !== 'id' && key !== 'name'))
      })
      return [...new Set(fields)]
    }
  }

  get batchesFields () {
    return (facility: any) => {
      const fields: string[] = []
      facility.batches.forEach((batch: Partial<IBatch>[]) => {
        fields.push(...Object.keys(batch).filter((key: string) => key !== 'id' && key !== 'markStatementsDoNotBill'))
      })
      return [...new Set(fields)]
    }
  }

  get collectionSetting () {
    return (collectionSetting: any) => Object.keys(collectionSetting).filter((key: string) => key !== 'id')
  }

  get advancedSettings () {
    return (advancedSettings: any) => Object.keys(advancedSettings).filter((key: string) => key !== 'id' && key !== 'name')
  }

  get batches () {
    return (batches: any) => Object.keys(batches).filter((key: string) => key !== 'id' && key !== 'markStatementsDoNotBill')
  }

  getUserGeneralFacilityAndPaymentsAssignmentFields (assignment: UserAssignment) {
    const facilityAndPaymentAssignmentFields: (keyof IFacility)[] = ['paymentsReviewManager', 'syncPaymentUser', 'residentBillingContact']
    const userGeneralFacilityAndPaymentsAssignmentFields = Object.keys(assignment).filter(
      assignmentKey => facilityAndPaymentAssignmentFields.includes(assignmentKey as any)
    ) as (keyof Pick<IFacility, 'paymentsReviewManager' | 'syncPaymentUser' | 'residentBillingContact'>)[]
    return userGeneralFacilityAndPaymentsAssignmentFields
  }

  getUserCollectionSettingsAssignmentFields (assignment: UserAssignment) {
    if (!assignment.collectionSetting) {
      return []
    }
    const collectionSettingsAssignmentFields: (keyof IFacilityCollectionSettings)[] = ['newCollectionsUser', 'escalatedIssuesUser']
    const userCollectionAssignmentFields = Object.keys(assignment.collectionSetting).filter(
      assignmentKey => collectionSettingsAssignmentFields.includes(assignmentKey as any)) as (
      keyof Pick<IFacilityCollectionSettings, 'newCollectionsUser' | 'escalatedIssuesUser'>
    )[]
    return userCollectionAssignmentFields
  }

  getUserAdvancedSettingsAssignmentFields (assignment: UserAssignment) {
    if (!Array.isArray(assignment.advancedSettings)) {
      return []
    }
    const fieldsFromAllAssignments = new Set<string>()
    assignment.advancedSettings.forEach(as => {
      if (isObj(as)) { Object.keys(as).forEach(asField => isString(asField) && fieldsFromAllAssignments.add(asField)) }
    })

    const advancedSettingsAssignmentFields: (keyof IFacilityAdvancedSettings)[] = ['billingContact', 'printedStatementUser', 'reviewUser']
    const userAdvancedSettingsAssignmentFields = Array.from(fieldsFromAllAssignments).filter(
      assignmentKey => advancedSettingsAssignmentFields.includes(assignmentKey as any)) as (
      keyof Pick<IFacilityAdvancedSettings, 'billingContact' | 'printedStatementUser' | 'reviewUser'>
    )[]
    return userAdvancedSettingsAssignmentFields
  }

  getUserBatchesAssignmentFields (assignment: UserAssignment) {
    if (!Array.isArray(assignment.batches)) {
      return []
    }
    const fieldsFromAllAssignments = new Set<string>()
    assignment.batches.forEach(as => {
      if (isObj(as)) { Object.keys(as).forEach(asField => isString(asField) && fieldsFromAllAssignments.add(asField)) }
    })
    const batchesAssignmentFields: (keyof IBatch)[] = ['billingContact', 'printedStatementUser', 'reviewUser']
    const userBatchesAssignmentFields = Array.from(fieldsFromAllAssignments).filter(
      assignmentKey => batchesAssignmentFields.includes(assignmentKey as any)) as (
      keyof Pick<IBatch, 'billingContact' | 'printedStatementUser' | 'reviewUser'>
    )[]
    return userBatchesAssignmentFields
  }

  get advancedSettingsFieldReassignment () {
    return (
      assignmentId: number,
      field: keyof Pick<IFacilityAdvancedSettings, 'billingContact' | 'printedStatementUser' | 'reviewUser'>
    ) => {
      const userReassignment = this.userReassignmentsByFacility[assignmentId]
      if (!userReassignment) {
        return
      }
      const advancedSettingsReassignment = userReassignment.advancedSettings
      if (!advancedSettingsReassignment) {
        return
      }
      return advancedSettingsReassignment[field]
    }
  }

  get collectionSettingsFieldReassignment () {
    return (
      assignmentId: number,
      field: keyof Pick<IFacilityCollectionSettings, 'newCollectionsUser' | 'escalatedIssuesUser'>
    ) => {
      const userReassignment = this.userReassignmentsByFacility[assignmentId]
      if (!userReassignment) {
        return
      }
      const collectionSettingsReassignment = userReassignment.collectionSettings
      if (!collectionSettingsReassignment) {
        return
      }
      return collectionSettingsReassignment[field]
    }
  }

  get facilityAndPaymentFieldReassignment () {
    return (
      assignmentId: number,
      field: keyof Pick<IFacility, 'paymentsReviewManager' | 'syncPaymentUser' | 'residentBillingContact'>
    ) => {
      const userReassignment = this.userReassignmentsByFacility[assignmentId]
      if (!userReassignment) {
        return
      }
      const generalFacilitySettingsReassignment = userReassignment.generalFacilitySettings
      if (!generalFacilitySettingsReassignment) {
        return
      }
      return generalFacilitySettingsReassignment[field]
    }
  }

  get batchesFieldReassignment () {
    return (
      assignmentId: number,
      field: keyof Pick<IBatch, 'billingContact' | 'printedStatementUser' | 'reviewUser'>
    ) => {
      const userReassignment = this.userReassignmentsByFacility[assignmentId]
      if (!userReassignment) {
        return
      }
      const batchesReassignment = userReassignment.batches
      if (!batchesReassignment) {
        return
      }
      return batchesReassignment[field]
    }
  }

  get batchesDoNotBillReassignment () {
    return (assignmentId: number) => {
      const userReassignment = this.userReassignmentsByFacility[assignmentId]
      if (!userReassignment) {
        return
      }
      const batchesReassignment = userReassignment.batches
      if (!batchesReassignment) {
        return
      }
      return batchesReassignment.markStatementsDoNotBill
    }
  }

  get facilityFields () {
    return (facility: any) => {
      return Object.keys(facility).filter((key: string) => !['id', 'name', 'advancedSettings', 'batches', 'batch', 'collectionSetting'].includes(key))
    }
  }

  get facilityManagersList () {
    return this.$store.state.user.usersAll
  }

  get facilityManagersListForSelect () {
    return (facilityId: number) => this.facilityManagersList
      .filter((manager: IUser) => this.$props.userToDelete !== manager.id && manager.status === EUserStatus.ACTIVE && (manager.isAllFacilities || manager.facilities.some(el => Number(el) === facilityId)))
      .map((manager: IUser) => ({
        key: manager.id,
        value: manager.id,
        content: `${manager.firstName} ${manager.lastName}`
      }))
  }

  get allFacilitiesManagersListForSelect () {
    const facilitiesToUpdate = this.userAssignments.map(assignment => assignment.id)
    return this.facilityManagersList
      .filter((manager: IUser) => (
        manager.status === EUserStatus.ACTIVE &&
        (manager.isAllFacilities || facilitiesToUpdate.every(el => manager.facilities.includes(String(el) as any))) &&
        manager.id !== this.$props.userToDelete
      )).map((manager: IUser) => ({
        key: manager.id,
        value: manager.id,
        content: `${manager.firstName} ${manager.lastName}`
      }))
  }

  get userToDeleteNamePlaceHolder () {
    const nameOfUser = this.facilityManagersList.find((manager: IUser) => this.$props.userToDelete === manager.id)
    return nameOfUser ? `${nameOfUser.firstName} ${nameOfUser.lastName}` : null
  }
  get labelFieldMap () {
    return {
      'syncPaymentUser': 'Responsible to sync and post payments in PCC',
      'paymentsReviewManager': 'Review payments',
      'residentBillingContact': 'Default Billing Contact',
      'billingContact': 'Statement Billing Contact',
      'printedStatementUser': 'Printed statements delivered by',
      'reviewUser': 'Statements are reviewed/mailed by',
      'newCollectionsUser': 'New/Existing Collections assigned to',
      'escalatedIssuesUser': 'Escalated collections are assigned to'
    }
  }

  async mounted () {
    try {
      this.isLoading = true
      await this.userModuleInstance.getManagementUsersAll()
      this.userAssignments = [...this.userAssignmentsStore.sort(
        (a: IFacility & any, b: IFacility & any) => (a.shortName || a.name).localeCompare((b.shortName || b.name))
      )]
      this.openedSections.push(this.userAssignments[0].id as number)
      this.userAssignments.forEach((assignment) => {
        if (assignment.batches) {
          assignment.batches.forEach((b: UserBatchesReassignmentData) => {
            b.markStatementsDoNotBill = false
          })
        }
        this.showAutofillMap[assignment.id as number] = false
        this.userReassignmentsByFacility[assignment.id as number] = { facilityId: assignment.id as number, userId: this.$props.userToDelete }
      })
    } finally {
      this.isLoading = false
    }
  }

  beforeDestroy () {
    this.userModuleInstance.SET_CHECK_USER_ASSIGNMENTS([])
  }

  validate () {
    let isValid: boolean = true

    Object.values(this.userAssignments).forEach((assignment: UserAssignment, index: number) => {
       if (!this.validateSection(assignment)) {
         isValid = false
       }
    })

    return isValid
  }

  validateSection (assignment: UserAssignment) {
    let isValid: boolean = true
    const userReassignment = this.userReassignmentsByFacility[assignment.id!]
    const userGeneralFacilityAndPaymentsAssignmentFields = this.getUserGeneralFacilityAndPaymentsAssignmentFields(assignment)
    userGeneralFacilityAndPaymentsAssignmentFields.forEach(field => {
      const userGeneralFacilityAndPaymentsReassignment = userReassignment.generalFacilitySettings
      if (
        !userGeneralFacilityAndPaymentsReassignment ||
        !userGeneralFacilityAndPaymentsReassignment[field] ||
        userGeneralFacilityAndPaymentsReassignment[field] === this.$props.userToDelete
      ) {
        isValid = false
      }
    })

    Object.keys(assignment).forEach((field: string) => {
      if (!userReassignment) {
        isValid = false
        return
      }

      if (field === 'collectionSetting' && isObj(assignment.collectionSetting)) {
        if (!userReassignment.collectionSettings) {
          isValid = false
          return
        }
        const userCollectionAssignmentsFields = this.getUserCollectionSettingsAssignmentFields(assignment)
        userCollectionAssignmentsFields.forEach(field => {
          const userCollectionReassignment = userReassignment.collectionSettings
          if (
            !userCollectionReassignment ||
            !userCollectionReassignment[field] ||
            userCollectionReassignment[field] === this.$props.userToDelete
          ) {
            isValid = false
          }
        })
      }

      if (field === 'advancedSettings' && assignment.advancedSettings && isObj(assignment.advancedSettings[0])) {
        if (!userReassignment.advancedSettings) {
          isValid = false
          return
        }
        const userAdvancedSettingsAssignmentFields = this.getUserAdvancedSettingsAssignmentFields(assignment)
        userAdvancedSettingsAssignmentFields.forEach(field => {
          const userAdvancedSettingsReassignment = userReassignment.advancedSettings
          if (
            !userAdvancedSettingsReassignment ||
            !userAdvancedSettingsReassignment[field] ||
            userAdvancedSettingsReassignment[field] === this.$props.userToDelete
          ) {
            isValid = false
          }
        })
      }

      if (field === 'batches' && assignment.batches && isObj(assignment.batches[0])) {
        if (!userReassignment.batches) {
          isValid = false
          return
        }
        const userBatchesAssignmentFields = this.getUserBatchesAssignmentFields(assignment)
        userBatchesAssignmentFields.forEach(field => {
          const userBatchesReassignment = userReassignment.batches
          if (
            !userBatchesReassignment ||
            !userBatchesReassignment[field] ||
            userBatchesReassignment[field] === this.$props.userToDelete
          ) {
            isValid = false
          }
        })
      }
    })
    return isValid
  }

  async save () {
    if (!this.validate()) {
      this.errors = ['You have to update all fields to disable user']
      return
    }
    this.isLoading = true
    await this.userModuleInstance.makeUserReassignments(Object.values(this.userReassignmentsByFacility))

    this.isLoading = false
    this.$emit('submit')
  }

  setOpenedSection (id: number) {
    this.openedSections.splice(0, 1)
    this.openedSections.push(id)
  }

  toggleAutofillAll () {
    this.showAutofillAll = !this.showAutofillAll
  }

  toggleAutofill (facilityId: number) {
    this.$set(this.showAutofillMap, facilityId, !this.showAutofillMap[facilityId])
    this.$forceUpdate()
  }

  setReassignmentGeneralAndPaymentSettings (
    assignmentId: number,
    field: keyof Pick<IFacility, 'paymentsReviewManager' | 'syncPaymentUser' | 'residentBillingContact'>,
    userId: number
  ) {
    const userReassignment = this.userReassignmentsByFacility[assignmentId!]
    if (!userReassignment.generalFacilitySettings) {
      userReassignment.generalFacilitySettings = {}
    }
    userReassignment.generalFacilitySettings[field] = userId
  }

  setReassignmentCollectionSettings (
    assignmentId: number,
    field: keyof Pick<IFacilityCollectionSettings, 'newCollectionsUser' | 'escalatedIssuesUser'>,
    userId: number
  ) {
    const userReassignment = this.userReassignmentsByFacility[assignmentId!]
    if (!userReassignment.collectionSettings) {
      userReassignment.collectionSettings = {}
    }
    userReassignment.collectionSettings[field] = userId
  }

  setReassignmentAdvancedSettings (
    assignmentId: number,
    field: keyof Pick<IFacilityAdvancedSettings, 'billingContact' | 'printedStatementUser' | 'reviewUser'>,
    userId: number
  ) {
    const userReassignment = this.userReassignmentsByFacility[assignmentId!]
    if (!userReassignment.advancedSettings) {
      userReassignment.advancedSettings = {}
    }
    userReassignment.advancedSettings[field] = userId
  }

  setAssignmentBatches (
    assignmentId: number,
    field: keyof Pick<UserBatchesReassignmentData, 'billingContact' | 'printedStatementUser' | 'reviewUser'>,
    userId: number
  ) {
    const userReassignment = this.userReassignmentsByFacility[assignmentId!]
    if (!userReassignment.batches) {
      userReassignment.batches = {}
    }
    userReassignment.batches[field] = userId
  }

  markBatchesDoNotBill (assignmentId: number, value: boolean) {
    const arrIndex: number = this.userAssignments.findIndex(el => el.id === assignmentId)
    const userAssignment = this.userAssignments[arrIndex]
    if (!userAssignment) {
      console.error(`Assignment at index ${arrIndex} not found`)
      return
    }
    const userReassignment = this.userReassignmentsByFacility[userAssignment.id!]
    if (!userReassignment.batches) {
      userReassignment.batches = { markStatementsDoNotBill: value }
    }
    userReassignment.batches.markStatementsDoNotBill = value
  }

  bulkSetUserAssignments (facilityId?: number) {
    const userAssignments: UserAssignment[] = []
    let userId: any

    if (facilityId) {
      userId = this.autofillUserMap[facilityId]
      const assignment = this.userAssignments.find(assignment => assignment.id === facilityId)
      if (assignment) {
        userAssignments.push(assignment)
      }
    } else {
      userId = this.autofillAllUser
      userAssignments.push(...this.userAssignments)
    }

    if (!userId) {
      return
    }

    userAssignments.forEach((assignment: UserAssignment) => {
      const userReassignment = this.userReassignmentsByFacility[assignment.id!]
      if (!userReassignment) {
        return
      }

      if (assignment.collectionSetting && Object.keys(assignment.collectionSetting).length) {
        const userCollectionAssignmentFields = this.getUserCollectionSettingsAssignmentFields(assignment)
        userCollectionAssignmentFields.forEach(
          field => this.setReassignmentCollectionSettings(assignment.id!, field, userId)
        )
      }

      if (assignment.advancedSettings && Object.keys(assignment.advancedSettings).length) {
        const userAdvancedSettingsAssignments = this.getUserAdvancedSettingsAssignmentFields(assignment)
        userAdvancedSettingsAssignments.forEach(
          field => this.setReassignmentAdvancedSettings(assignment.id!, field, userId)
        )
      }

      if (assignment.batches && Object.keys(assignment.batches).length) {
        const userBatchesAssignments = this.getUserBatchesAssignmentFields(assignment)
        userBatchesAssignments.forEach(
          field => this.setAssignmentBatches(assignment.id!, field, userId)
        )
      }

      const userGeneralFacilityAndPaymentsAssignmentFields = this.getUserGeneralFacilityAndPaymentsAssignmentFields(assignment)
      if (userGeneralFacilityAndPaymentsAssignmentFields.length) {
        userGeneralFacilityAndPaymentsAssignmentFields.forEach(
          field => this.setReassignmentGeneralAndPaymentSettings(assignment.id!, field, userId)
        )
      }
    })
  }
}
